<template>
  <div 
    class="mt-5 px-7">
    <v-layout wrap>
      <v-flex>
        <section>
          
          
          <v-row
            class="">
            <v-col 
              cols="12"
              class="px-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="background: #fff;">
                <v-card-text>
                  <div class="black--text fs-18 mb-2 font-weight-bold">
                      Mengubah Varian
                    </div>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <!-- <div
                        class="mb-4">
                        <div 
                          class="body-2 mb-2">
                          Poto Profil
                        </div>

                        <uploadfolder v-if="form.image_url === ''"
                          v-model="upload.image">
                          <div 
                            slot="activator">
                            <v-card 
                              flat
                              width="200"
                              height="200"
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 15px;
                                    border: 2px solid #EBEBEB; 
                                    border-style: dashed;">
                              <v-avatar v-if="!process.image"
                                v-ripple
                                tile 
                                width="200"
                                height="200">
                                <v-icon
                                  size="50"
                                  color="#B9B9B9">
                                  mdi-cloud-upload-outline
                                </v-icon>
                              </v-avatar>

                              <v-progress-circular v-else
                                indeterminate
                                :color="set_color">
                              </v-progress-circular>
                            </v-card>
                          </div>
                        </uploadfolder>

                        <v-card v-if="form.image_url !== ''"
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar
                            v-ripple
                            tile 
                            size="200"
                            style="border-radius: 15px;">
                            <v-img 
                              contain
                              width="100%"
                              height="100%"
                              alt="Mitra Warung" 
                              :src="form.image_url"
                              class="ma-auto"
                              style="border-radius: 15px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>

                          <v-icon 
                            @click="form.image_url = ''"
                            color="red"
                            class="cursor-pointer"
                            style="position: absolute; top: -10px; right: -10px;">
                            mdi-close-circle
                          </v-icon>
                        </v-card>
                      </div> -->

                      <v-row>
                        <v-col cols="12">
                          <ValidationProvider
                            name="Produk" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Produk
                            </div>
      
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
      
                              color="#718EBF"
                              placeholder="Produk"
      
                              
                              :items="product"
                              item-value="id"
                              item-text="name"
                              :item-color="set_color"
      
                              v-model="form.product_id"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6" class="pt-0">
                          <ValidationProvider
                            name="Nama" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Nama
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Nama"
        
                              
        
                              v-model="form.name"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col
                          cols="12"
                          md="6" class="pt-0">
                          <ValidationProvider
                            name="SKU" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              SKU
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="SKU"
        
                              
        
                              v-model="form.sku"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                        </v-col>

                        <v-col
                          cols="12"
                          md="2" class="pt-0">
                          <ValidationProvider
                            name="Berat" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Berat
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              
        
                              placeholder="Berat"
        
                              
        
                              v-model="form.berat"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="3" class="pt-0">
                          <ValidationProvider
                            name="Dimensi" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Dimensi
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Dimensi"
        
                              
        
                              v-model="form.dimensi"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                        
                        <v-col
                        cols="12"
                        md="2" class="pt-0">
        
        


                          <!-- <ValidationProvider
                            name="Minimal Stok" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              Minimal Stok
                            </div>
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Minimal Stok"
                              type="number"
                              min="0"
        
                              
        
                              v-model="form.min_stock"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider> -->
                          
                          <ValidationProvider
                            name="Jumlah Dalam Dus" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Jumlah Dalam Dus
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Jumlah Dalam Dus"
                              type="number"
                              min="0"
        
                              v-model="form.total_in_dus"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
        
                          <!-- <ValidationProvider
                            name="Minimal Order" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              Minimal Order
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              type="number"
                              min="0"
                              placeholder="Minimal Order"
        
                              
        
                              v-model="form.min_order"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider> -->
                          
                        </v-col>
                        <v-col cols="12" md="2" class="pt-0">
                          <ValidationProvider
                            name="Minimal Satuan" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Minimal Satuan
                            </div>
        
                            <v-autocomplete
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Minimal Satuan"
                              :items="[ 'Pcs', 'Lusin', 'Dus' ]"
        
                              v-model="form.unit"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-autocomplete>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" md="3" class="pt-0">


                          <ValidationProvider
                            name="Harga pricelist pcs + PPN" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga pricelist pcs + PPN
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga pricelist pcs + PPN"
        
                              :auto-decimal-mode="false"
                              :decimal-length="2"
        
                              v-model="form.pricelist_pcs_ppn"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                        </v-col>
                        
                        <!-- <v-col
                        cols="12"
                        md="3" class="pt-0">
        
                          <ValidationProvider
                            name="Berat" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Berat
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              
        
                              placeholder="Berat"
        
                              
        
                              v-model="form.berat"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Dimensi" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Dimensi
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Dimensi"
        
                              
        
                              v-model="form.dimensi"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>


                          <ValidationProvider
                            name="Minimal Stok" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Minimal Stok
                            </div>
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Minimal Stok"
                              type="number"
                              min="0"
        
                              
        
                              v-model="form.min_stock"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                          
                          <ValidationProvider
                            name="Jumlah Dalam Dus" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Jumlah Dalam Dus
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Jumlah Dalam Dus"
                              type="number"
                              min="0"
        
                              v-model="form.total_in_dus"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Minimal Order" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Minimal Order
                            </div>
        
                            <v-text-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              type="number"
                              min="0"
                              placeholder="Minimal Order"
        
                              
        
                              v-model="form.min_order"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                          
                        </v-col>
                        
                        <v-col
                          cols="12"
                          md="3" class="pt-0">
                          <ValidationProvider
                            name="Harga DPP Jual" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga DPP Jual
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga DPP Jual"

                              v-on:change="change_pricelist_pcs_ppn()"
                              
        
                              v-model="form.dpp_jual"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Biaya lainnya jual 1" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Biaya lainnya jual 1
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Biaya lainnya jual 1"
                              type="number"
                              v-on:change="change_pricelist_pcs_ppn()"
        
                              v-model="form.biaya_lainnya_jual_1"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Biaya lainnya jual 2" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Biaya lainnya jual 2
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              type="number"
                              v-on:change="change_pricelist_pcs_ppn()"
                              
        
                              placeholder="Biaya lainnya jual 2"
        
                              
        
                              v-model="form.biaya_lainnya_jual_2"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Harga pricelist exclude PPN" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga pricelist exclude PPN
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
                              
        
                              color="#718EBF"
                              placeholder="Harga pricelist exclude PPN"
                              
        
                              v-model="form.pricelist_exclude_ppn"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Harga pricelist pcs + PPN" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga pricelist pcs + PPN
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
                              readonly
        
                              color="#718EBF"
                              placeholder="Harga pricelist pcs + PPN"
        
                              
        
                              v-model="form.pricelist_pcs_ppn"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                          
                        </v-col>

                        <v-col
                          cols="12"
                          md="3" class="pt-0">
                          <ValidationProvider
                            name="Harga DPP Beli" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga DPP Beli
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga DPP Beli"
        
                              v-on:change="change_dpp_beli()"
        
                              v-model="form.dpp_beli"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Biaya PPN Beli" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Biaya PPN Beli
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Biaya PPN Beli"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              v-on:change="change_harga_beli_ppn()"
        
                              v-model="form.ppn_beli"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Harga beli include PPN" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga beli include PPN
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              type="number"
                              readonly
        
                              placeholder="Harga beli include PPN"
        
                              
        
                              v-model="form.harga_beli_ppn"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Harga pricelist lusin + PPN" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga pricelist lusin + PPN
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga pricelist lusin + PPN"
        
                              
        
                              v-model="form.pricelist_lusin_ppn"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Harga pricelist dus + PPN" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga pricelist dus + PPN
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga pricelist dus + PPN"
        
                              
        
                              v-model="form.pricelist_dus_ppn"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                          
                        </v-col>

                        <v-col
                          cols="12"
                          md="3" class="pt-0">
                          <ValidationProvider
                            name="Harga lainnya" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga lainnya
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga lainnya"
                              v-on:change="change_harga_hpp_pcs()"
                              
        
                              v-model="form.harga_lainnya"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Harga pengiriman" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga pengiriman
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga pengiriman"
                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              v-on:change="change_harga_hpp_pcs()"
        
                              v-model="form.harga_pengiriman"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
        
                          <ValidationProvider
                            name="Harga HPP pcs" 
                            rules="required|min:0" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga HPP pcs
                            </div>
        
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              type="number"
                              
        
                              placeholder="Harga HPP pcs"
                              readonly
                              
        
                              v-model="form.harga_hpp_pcs"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Harga HPP Lusin" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga HPP Lusin
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga HPP Lusin"
        
                              
        
                              v-model="form.harga_hpp_lusin"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>

                          <ValidationProvider
                            name="Harga HPP dus" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Harga HPP dus
                            </div>
                            <v-currency-field
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Harga HPP dus"
        
                              
        
                              v-model="form.harga_hpp_dus"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-currency-field>
                          </ValidationProvider>
                          
                        </v-col> -->

                        <v-col cols="12">
                          <ValidationProvider
                            name="Deskripsi" 
                            rules="required" 
                            v-slot="{ errors }">
                            <div 
                              class="fs-13 label-input">
                              
                              Deskripsi
                            </div>
        
                            <v-textarea
                              v-on:keydown.enter.prevent="save()"
                              
                              filled
                              rounded
                              dense
                              solo
        
                              color="#718EBF"
                              placeholder="Deskripsi"
                              row="2"
        
                              
        
                              v-model="form.desc"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-textarea>
                          </ValidationProvider>


                          <div 
                            class="fs-13 label-input">
                            
                            Gambar
                          </div>
                          <v-row>
                            <v-col 
                              v-for="(item, index) in form.images"
                              :key="index"
                              cols="12"
                              md="4">
                              <v-card 
                                flat
                                width="100%"
                                height="300"
                                class="d-flex align-center justify-center"
                                style="border-radius: 15px;
                                      border: 2px solid #eaeaea; 
                                      border-style: dashed;
                                      box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px; ">
                                <v-img 
                                  alt="megavin" 
                                  width="100%"
                                  height="196"
                                  :src="item"
                                  contain
                                  class="ma-auto">
                                  <template v-slot:placeholder>
                                    <v-row
                                      class="fill-height"
                                      align="center"
                                      justify="center">
                                      <v-progress-circular 
                                        indeterminate 
                                        :color="set_color">
                                      </v-progress-circular>
                                    </v-row>
                                  </template>

                                  <div 
                                    @click="form.images.splice(index, 1)"
                                    class="cursor-pointer"
                                    style="position: absolute; top: 5px; right: 5px;">
                                    <v-icon size="24" color="red">mdi-close-circle</v-icon>
                                  </div>
                                </v-img>
                              </v-card>
                            </v-col>

                            <v-col
                              cols="12"
                              md="4">
                              <uploadfolder 
                                v-model="upload.images">
                                <div 
                                  slot="activator" 
                                  class="cursor-pointer">
                                  <v-card 
                                    flat
                                    width="100%"
                                    height="300"
                                    class="d-flex align-center justify-center"
                                    style="border-radius: 15px;
                                          border: 2px solid #eaeaea; 
                                          border-style: dashed;">
                                    <v-icon v-if="!process.file"
                                      size="60" 
                                      color="grey">
                                      mdi-cloud-upload-outline
                                    </v-icon>

                                    <v-progress-circular v-else
                                      indeterminate
                                      :color="set_color">
                                    </v-progress-circular>
                                  </v-card>
                                </div>
                              </uploadfolder>
                            </v-col>
                          </v-row>

                        </v-col>
                      </v-row>

                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#1814F3"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
              
              <v-btn
                @click="$router.go(-1)"
                :disabled="process.form"
                color="red"
                elevation="0"
                width="140"
                height="45"
                class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                style="font-weight: 600;">
              
                  Batal
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        form: {
          id: '',
          product_id: '',
          name: '',
          sku: '',
          images: '',
          berat: '',
          dimensi: '',
          desc: '',
          min_stock: 0,
          total_in_dus: 0,
          unit: '',
          min_order: 0,
          dpp_jual: 0,
          biaya_lainnya_jual_1: 0,
          biaya_lainnya_jual_2: 0,
          pricelist_exclude_ppn: 0,
          pricelist_pcs_ppn: 0,
          pricelist_lusin_ppn: 0,
          pricelist_dus_ppn: 0,
          harga_beli_ppn: 0,
          ppn_beli: 0,
          dpp_beli: 0,
          harga_lainnya: 0,
          harga_pengiriman: 0,
          harga_hpp_pcs: 0,
          harga_hpp_lusin: 0,
          harga_hpp_dus: 0
        },
        product: [],

        upload: {
          ttd: null,
          images: null
        },

        process: {
          form: false,

          ttd: false,

          images: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.ttd': {
        handler: function () {
          if (this.upload.ttd) {
            this.process.ttd = this.upload.ttd.process

            if (!this.process.ttd) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.ttd = this.upload.ttd.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },

      'upload.images': {
        handler: function () {
          if (this.upload.images) {
            this.process.images = this.upload.images.process

            if (!this.process.images) {
              // CALLBACK FROM UPLOAD IMAGE
              
              // this.form.images = this.upload.images.fileuri
              this.form.images.push(
                this.upload.images.fileuri
              )

              // this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get('admin/varian/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // this.form = res.results.data
            this.form.id = res.results.data.id
            this.form.product_id = res.results.data.product_id
            this.form.name = res.results.data.name
            this.form.sku = res.results.data.sku
            this.form.images = JSON.parse(res.results.data.images)
            this.form.berat = res.results.data.berat
            this.form.dimensi = res.results.data.dimensi
            this.form.desc = res.results.data.desc
            this.form.min_stock = res.results.data.min_stock
            this.form.total_in_dus = res.results.data.total_in_dus
            this.form.unit = res.results.data.unit
            this.form.min_order = res.results.data.min_order
            this.form.dpp_jual = res.results.data.dpp_jual
            this.form.biaya_lainnya_jual_1 = res.results.data.biaya_lainnya_jual_1
            this.form.biaya_lainnya_jual_2 = res.results.data.biaya_lainnya_jual_2
            this.form.pricelist_exclude_ppn = res.results.data.pricelist_exclude_ppn
            this.form.pricelist_pcs_ppn = res.results.data.unit == 'Dus' ? Math.ceil((res.results.data.pricelist_pcs_ppn*1) * (res.results.data.total_in_dus*1)) : res.results.data.pricelist_pcs_ppn
            this.form.pricelist_lusin_ppn = res.results.data.pricelist_lusin_ppn
            this.form.pricelist_dus_ppn = res.results.data.pricelist_dus_ppn
            this.form.harga_beli_ppn = res.results.data.harga_beli_ppn
            this.form.ppn_beli = res.results.data.ppn_beli
            this.form.dpp_beli = res.results.data.dpp_beli
            this.form.harga_lainnya = res.results.data.harga_lainnya
            this.form.harga_pengiriman = res.results.data.harga_pengiriman
            this.form.harga_hpp_pcs = res.results.data.harga_hpp_pcs
            this.form.harga_hpp_lusin = res.results.data.harga_hpp_lusin
            this.form.harga_hpp_dus = res.results.data.harga_hpp_dus


          }
        this.fetchProduct()
        })
      },
      async fetchProduct() {

         let params = {
          limit: 10000000000000
        }

        await get(`admin/product/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.product = res.results.data
          }
        })
      },
      change_pricelist_pcs_ppn() {
        this.form.pricelist_pcs_ppn = this.form.dpp_jual*1 + this.form.biaya_lainnya_jual_1*1 + this.form.biaya_lainnya_jual_2*1
      },
      change_dpp_beli() {
        this.form.harga_hpp_pcs = this.form.dpp_beli*1 + this.form.harga_pengiriman*1 + this.form.harga_lainnya*1
        this.form.harga_beli_ppn = this.form.dpp_beli*1 + this.form.ppn_beli*1
      },
      change_harga_beli_ppn() {
        this.form.harga_beli_ppn = this.form.dpp_beli*1 + this.form.ppn_beli*1
      },
      change_harga_hpp_pcs() {
        this.form.harga_hpp_pcs = this.form.dpp_beli*1 + this.form.harga_pengiriman*1 + this.form.harga_lainnya*1
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          let form = {
            ...this.form,
            pricelist_pcs_ppn: this.form.unit === 'Dus' ? (this.form.pricelist_pcs_ppn*1)/(this.form.total_in_dus*1) : this.form.pricelist_pcs_ppn,
            images: JSON.stringify(this.form.images)
          }
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/varian/update`, {
            data: form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              // this.$router.push({ path: '/product/varian' })
              this.$router.go(-1)

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>